var Flickity = require('flickity'),
	$ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function MovieList(el) {
	var t = this,
		$el = $(el),
		$size = $el.find(".movie-list__list .js-movie-item").size(),
		$start = 5,
		$loadMore = $el.find('.js-load-more'),
		currentSlide = Math.ceil($el.find('.js-current-date').index() / 5) - 1;

	t.slider = el.querySelector('[data-slider]');
	t.slideBreakpoint = 768;

	var slider = new Flickity(t.slider, {
		cellAlign: 'left',
		contain: true,
		adaptiveHeight: true,
		prevNextButtons: true,
		pageDots: false,
		setGallerySize: true,
		groupCells: $(window).width() > t.slideBreakpoint ? 5 : 2,
		// Improve accessibility for slider
		on: {
			ready: function() {
				$(this.prevButton.element).insertBefore(this.viewport);
				$(this.viewport).find('.movie-list__nav-item a').attr('tabindex', '-1');
				$(this.viewport).find('.movie-list__nav-item.is-selected a').attr('tabindex', '0');
			},
			change: function(index) {
				$(this.viewport).find('.movie-list__nav-item a').attr('tabindex', '-1');
				$(this.viewport).find('.movie-list__nav-item.is-selected a').attr('tabindex', '0');
			}
		}
	});

	slider.select(currentSlide);

	$el.find('.movie-list__list .js-movie-item:lt(' + $start + ')').addClass('movie-item--show');
	$loadMore.on('click', function () {
		if ($start + 5 < $size) {
			$start = $start + 5;
		} else {
			$start = $size;
		}
		$el.find('.movie-list__list .js-movie-item:lt(' + $start + ')').addClass('movie-item--show');
		if ( $start == $size ) {
			$loadMore.hide();
		}
	});
}

module.exports = MovieList;
